import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule, Routes} from '@angular/router';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import 'hammerjs';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {ToastrModule} from 'ngx-toastr'; // For auth after login toast
import {CoreModule} from '@core/core.module';
import {CoreCommonModule} from '@core/common.module';
// @ts-ignore
import {CoreSidebarModule, CoreThemeCustomizerModule} from '@core/components';
import {coreConfig} from 'app/app-config';
import {AppComponent} from 'app/app.component';
import {LayoutModule} from 'app/layout/layout.module';
import {SampleModule} from 'app/main/sample/sample.module';
import {DashboardModule} from './main/dashboard/dashboard.module';
import {SharedModule} from './shared/shared.module';
import {SnotifyModule, SnotifyService, ToastDefaults} from 'ng-snotify';
import {GlobalService, MomentService} from './shared/services/global.service';
import {AlertService} from './shared/services/alert.service';
import {HtpInterceptor} from './shared/services/interceptor.service';
import {AuthService} from './shared/auth/auth.service';
import {AuthGuard} from './shared/auth/auth-guard.service';
import {OwlDateTimeModule, OwlNativeDateTimeModule} from 'ng-pick-datetime';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {PERFECT_SCROLLBAR_CONFIG} from 'ngx-perfect-scrollbar';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import {ImageCropperModule} from 'ngx-image-cropper';
import {NgSelectModule} from '@ng-select/ng-select';
import {ProductModule} from './main/product/product.module';
import {ContentHeaderModule} from './layout/components/content-header/content-header.module';
import {PackageModule} from './main/package/package.module';
import {StocksModule} from './main/stocks/stocks.module';
import {UsersModule} from './main/users/users.module';
import {CartModule} from './main/cart/cart.module';
import {CheckoutModule} from './main/checkout/checkout.module';
import {SupportTicketsModule} from './main/support-tickets/support-tickets.module';
import {MyProfileModule} from './main/my-profile/my-profile.module';
import {AddressModule} from './main/address/address.module';
import {SettingModule} from './main/setting/setting.module';
import {MyWalletModule} from './main/my-wallet/my-wallet.module';
import {WithdrawActivationAmountModule} from './main/withdraw-activation-amount/withdraw-activation-amount.module';
import {TransactionHistoryModule} from './main/transaction-history/transaction-history.module';
import { SalesIncomeComponent } from './main/sales-income/sales-income.component';
import {SalesIncomeModule} from './main/sales-income/sales-income.module';

const appRoutes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule)
    },
    {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: '/auth/miscellaneous/error' // Error 404 - Page not found
    }
];

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};

@NgModule({
    declarations: [AppComponent, SalesIncomeComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes, {
            scrollPositionRestoration: 'enabled', // Add options right here
            relativeLinkResolution: 'legacy'
        }),
        TranslateModule.forRoot(),
        // NgBootstrap
        NgbModule,
        ToastrModule.forRoot(),
        CoreModule.forRoot(coreConfig),
        CoreCommonModule,
        CoreSidebarModule,
        CoreThemeCustomizerModule,
        SharedModule,
        LayoutModule,
        SampleModule,
        SnotifyModule,
        DashboardModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        PerfectScrollbarModule,
        ImageCropperModule,
        NgSelectModule,
        ProductModule,
        PackageModule,
        StocksModule,
        UsersModule,
        CartModule,
        CheckoutModule,
        ContentHeaderModule,
        SupportTicketsModule,
        MyProfileModule,
        AddressModule,
        SettingModule,
        MyWalletModule,
        WithdrawActivationAmountModule,
        TransactionHistoryModule,
        SalesIncomeModule
    ],
    bootstrap: [AppComponent],
    providers: [
        AuthService,
        AuthGuard,
        HtpInterceptor,
        GlobalService,
        AlertService,
        {provide: 'SnotifyToastConfig', useValue: ToastDefaults},
        SnotifyService,
        MomentService,
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
    ],
})
export class AppModule {
}
